import { Text, Icon } from '@doordash/design-language';
export var NavigationTypes = {
  Back: {
    icon: Icon.Types.ArrowLeft,
    accessibilityLabel: 'Back'
  },
  Menu: {
    icon: Icon.Types.Menu,
    accessibilityLabel: 'Menu'
  },
  Close: {
    icon: Icon.Types.Close,
    accessibilityLabel: 'Close'
  },
  None: 'None'
};
export var TextAlignments = {
  Left: Text.TextAlignments.Left,
  Center: Text.TextAlignments.Center
};